import { createLoan, getSignInfo, loanConfirm, sign, getCmbcUrlForSign, schedules, getContractInfo, initSupplementInfo, saveSupplementInfo, skipIdCard, uploadile, uploadFaceFile, photoVerifySubmit, livingCheck, extdata, getGPS, getWithdrawUrl, getPlanList, getLoanResult, getContractList, getExtShow, submitExtData } from '@/api/loan'
import { APPLY_STATUS } from './status';
import { each as _each } from 'lodash'
import Store from 'store'
import Vue from 'vue'
const state = {
    applyId: 0,
    applyBalance: 0,
    applyDays: 0,
    signInfo: {},
    needIdentity: false, // 上传身份证
    needSupplement: false, // 补充信息
    needSign: false, // 去签约
    needBindCard: false, // 去绑卡
    faceVerify: false, // 是否需要活体检测
    needNextForDL: false,
    loanInfo: {},
    loanConfirm: {},
    replaymentScheduleVoList: [],
    supplementInfo: {},
    monthPay: 0,
    planList: [],
    resultInfo: {},
    canSkipIdCardOcr: false,
    // contractList: [],
    // contractUrlList: [],
    extDataShow: {}
}
const getters = {
    termList: state => {
        let terms = []
        if (state.loanInfo.applyRangs) {
            let rangs = state.loanInfo.applyRangs;
            rangs.forEach((rang) => {
                if (state.applyBalance >= rang.min && state.applyBalance <= rang.max) {
                    terms = rang.terms
                    return
                }
            })
            return terms
        } else {
            if (state.applyBalance <= 5000) {
                terms = [3, 6, 12]
            }
            if (state.applyBalance > 5000 && state.applyBalance <= 20000) {
                terms = [6, 12, 18, 24]
            }
            if (state.applyBalance > 20000) {
                terms = [12, 18, 24]
            }
            return terms
        }
    },
    fee: state => {
        let feeList = state.signInfo.feeList
        let amount = 0
        if (feeList) {
            _each(feeList, (fee) => {
                amount += fee.feeAmount
            })
        }
        return amount
    },
    applyIdInStore() {
        let applyId = Store.get('applyId') || Vue.cookie('applyId');
        return applyId;
    }
}
const mutations = {
    'SET_APPLYBALANCE' (state, payload) {
        payload = Number(payload)
        if (isNaN(payload)) {
            state.applyBalance = 0
        } else {
            state.applyBalance = Math.max(payload, 0)
        }
    },
    'SET_TERM' (state, payload) {
        state.applyDays = payload
    },
    'SET_LOAN' (state, payload) {
        if (typeof payload === 'object') {
            state.loanInfo = payload
            state.applyId = payload.applyId
            Store.set('loanInfo', payload)
            Store.set('applyId', payload.applyId)
        } else {
            state.applyId = payload
            Store.set('applyId', payload)
        }
    },
    'SET_SIGN_INFO' (state, payload) {
        state.signInfo = payload
    },
    // 'SET_CONTRACT_LIST' (state, payload) {
    //   state.contractList = payload
    // },
    // 'SET_CONTRACT_URL_LIST' (state, payload) {
    //   state.contractUrlList = payload
    // },
    'SET_NEXT_STATE' (state, payload) {
        for (var i in payload) {
            if (payload.hasOwnProperty(i))
                state[i] = payload[i]
        }
    },
    'SET_FACE_VERIFY' (state, payload) {
        state.faceVerify = payload
    },
    'SET_SCHEDULE_INFO' (state, payload) {
        state.replaymentScheduleVoList = payload
        if (state.replaymentScheduleVoList.length > 0) {
            state.monthPay = state.replaymentScheduleVoList[0].resAmt
        }
    },
    'SET_SUPPLEMENT_INFO' (state, payload) {
        state.supplementInfo = payload
    },
    'SET_PLAN_LIST' (state, payload) {
        state.planList = payload
    },
    'SET_RESULT_INFO' (state, payload) {
        state.resultInfo = payload
    },
    'RESET_LOAN' (state) {
        state.applyId = 0
        state.applyBalance = 0
        state.applyDays = 0
        state.signInfo = {}
        state.needIdentity = false
        state.needSupplement = false
        state.faceVerify = false // 是否需要活体检测
        state.loanInfo = {}
        state.loanConfirm = {}
        state.replaymentScheduleVoList = []
        state.supplementInfo = {}
        state.monthPay = 0
        state.planList = []
        state.resultInfo = {}
        Store.set('applyId', 0)
    },
    'SET_CAN_SKIP_ID_CARD_OCR' (state, payload) {
        state.canSkipIdCardOcr = payload;
    },
    'SET_EXTDATA_SHOW' (state, payload) {
        state.extDataShow = payload;
    }
}
const actions = {
    sign({ state, commit }, payload) {
        return sign({
            applyId: getters.applyIdInStore(),
            ...payload
        }).then((data) => {
            commit('SET_FACE_VERIFY', data.faceVerify)
            return Promise.resolve(data)
        })
    },
    getSignInfo({ state, commit }, payload) {
        if (getters.applyIdInStore() == 0 && !isNaN(Number(payload))) {
            commit('SET_LOAN', Number(payload))
        }
        return getSignInfo(getters.applyIdInStore()).then((data) => {
            commit('SET_SIGN_INFO', data)
            commit('SET_APPLYBALANCE', data.applyBalance)
            commit('SET_TERM', data.applyDays)
            return Promise.resolve(data);
        })
    },
    getContractList({ state, commit }, payload) {
        return getContractList(payload.applyId, payload.type).then((data) => {
            return Promise.resolve(data);
        })
    },
    createLoan({ commit }) {
        return createLoan().then(data => {
            commit('SET_LOAN', data)
            return Promise.resolve()
        })
    },
    loanConfirm({ state, commit }, payload) {
        return loanConfirm({
            applyId: getters.applyIdInStore(),
            applyBalance: state.applyBalance,
            applyDays: state.applyDays,
            insuranceOn: false
        }).then((data) => {
            commit('SET_NEXT_STATE', {
                needNextForDL: false,
                needIdentity: false,
                needSupplement: false,
                needSign: false, // 去签约
                needBindCard: false, // 去绑卡
            })
            commit('SET_CAN_SKIP_ID_CARD_OCR', data.canSkipIdCardOcr);
            if (data.applyStatus === APPLY_STATUS.APPLY_IDENTITY_VALID) { // 1016:身份证上传页面
                commit('SET_NEXT_STATE', {
                    needIdentity: true
                })
            } else if (data.applyStatus === APPLY_STATUS.APPLY_SUPPLEMENT_VALID) { // 1029:补充信息
                commit('SET_NEXT_STATE', {
                        needSupplement: true
                    })
                    // commit('SET_VENDOR_SUPPLEMENT', {
                    //   needSupplement: true
                    // })
            } else if (data.applyStatus === APPLY_STATUS.CREDIT_LINE) { // 1001:签约页面
                commit('SET_NEXT_STATE', {
                        needSign: true
                    })
                    // return Promise.resolve()
            } else if (data.applyStatus === APPLY_STATUS.BIND_CARD) { // 3005:绑卡
                commit('SET_NEXT_STATE', {
                    needBindCard: true
                })
            } else {
                return Promise.reject()
            }
        })
    },
    getCmbcUrlForSign({ state }, payload) {
        return getCmbcUrlForSign({
            applyId: getters.applyIdInStore(),
            balance: state.applyBalance,
            term: state.applyDays,
            purpose: payload,
            source: 'h5_wallet_sign'
        })
    },
    schedules({ state, commit }) {
        schedules(getters.applyIdInStore()).then((data) => {
            commit('SET_SCHEDULE_INFO', data.replaymentScheduleVoList)
        })
    },
    getContractInfo({ state }, payload) {
        return getContractInfo({
            applyId: getters.applyIdInStore(),
            contractType: payload
        })
    },
    initSupplementInfo({ state, commit }) {
        return initSupplementInfo(getters.applyIdInStore()).then((data) => {
            commit('SET_SUPPLEMENT_INFO', data)
            return Promise.resolve()
        })
    },
    saveSupplementInfo({ state, commit }, payload) {
        let needIdentity = false
        return saveSupplementInfo({
            applyId: getters.applyIdInStore(),
            ...payload
        }).then((data) => {
            if (data.applyStatus === APPLY_STATUS.APPLY_IDENTITY_VALID) {
                needIdentity = true
            }
            commit('SET_NEXT_STATE', {
                needIdentity: needIdentity
            })
        })
    },
    skipIdCard({ state }) {
        return skipIdCard(getters.applyIdInStore())
    },
    uploadile({ state }, payload) {
        return uploadile({
            applyId: getters.applyIdInStore(),
            ...payload
        })
    },
    uploadFaceFile({ state }, payload) {
        return uploadFaceFile({
            applyId: getters.applyIdInStore(),
            ...payload
        })
    },
    photoVerifySubmit({ state }) {
        return photoVerifySubmit(getters.applyIdInStore())
    },
    livingCheck({ state }, payload) {
        return livingCheck(payload)
            .then(data => {
                return Promise.resolve(data);
            })
            .catch((err) => {
                return Promise.reject(err);
            })
    },
    extdata({ state }, payload) {
        return extdata(payload)
    },
    getExtShow({ state, commit }, payload) {
        return getExtShow(payload).then((data) => {
            commit('SET_EXTDATA_SHOW', data)
        })
    },
    submitExtData({ state }, payload) {
        return submitExtData(payload)
    },
    geo() {
        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((p) => {
                    // 记录经纬度信息
                    resolve({
                        status: 200,
                        data: {
                            longitude: p.coords.longitude,
                            latitude: p.coords.latitude
                        }
                    })
                }, (e) => {
                    reject({
                        status: 400,
                        message: e.message
                    })
                });
            } else {
                reject({
                    status: 400,
                    message: '不支持定位'
                })
            }
        })
    },
    remoteGPS() {
        return getGPS()
    },
    getWithdrawUrl({ state }, payload) {
        return getWithdrawUrl({
            applyId: getters.applyIdInStore(),
            balance: state.applyBalance,
            term: state.applyDays,
            purpose: payload,
            callback: '',
            source: 'h5_wallet_sign'
        })
    },
    getPlanList({ commit }, payload) {
        return getPlanList({ applyId: payload }).then(data => {
            commit('SET_PLAN_LIST', data)
            return Promise.resolve()
        })
    },
    getLoanResult({ state, commit }, payload) {
        if (!isNaN(Number(payload))) {
            commit('SET_LOAN', Number(payload))
        }
        return getLoanResult({
            applyId: getters.applyIdInStore()
        }).then((data) => {
            commit('SET_RESULT_INFO', data)
            return Promise.resolve()
        })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}